import { InjectionToken } from '@angular/core';

export interface SidebarConfig {
  breakpoint: number;
  overlayWidth: number;
}

export const SIDEBAR_CONFIG = new InjectionToken<SidebarConfig>('SidebarConfig', {
  providedIn: 'root',
  factory: () => ({ breakpoint: 1800, overlayWidth: 900 })
});
